import React from 'react';

const Careers = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['work', 'person_add', 'school', 'trending_up', 'emoji_events', 'groups', 'handshake', 'star'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Join Our Team
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Career Opportunities
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Successful Careers Start Here
            </p>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Join Our Team</h2>
            <p>Explore career opportunities with Arizona's largest mechanical contractor</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Bel-Aire Mechanical is Arizona's mechanical contractor. We are centrally located in Phoenix, AZ. 
                Our principal corporate office building and expanded pipe, plumbing and sheet metal manufacturing 
                facilities are all <strong style={{color: 'var(--accent-blue)'}}>state-of-the-art</strong>.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                To view our career opportunities, follow the link below and you will be redirected to not only 
                Bel-Aire Mechanical's job postings, but also all companies that fall under the 
                <strong style={{color: 'var(--accent-blue)'}}> Legence umbrella</strong>. 
                Bel-Aire Mechanical is a Legence company.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Career Opportunities Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto', marginBottom: '3rem'}}>
            <div style={{background: 'var(--secondary-light)', padding: '2.5rem', borderRadius: '10px', marginBottom: '2rem', textAlign: 'center'}}>
              <h3 style={{fontSize: '1.5rem', color: 'var(--accent-blue)', marginBottom: '1.5rem'}}>Ready to Start Your Career?</h3>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Explore all available positions across the Legence family of companies
              </p>
              <a 
                href="https://us62e2.dayforcehcm.com/CandidatePortal/en-US/legence" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)',
                  color: 'var(--white)',
                  padding: '1rem 2.5rem',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  boxShadow: '0 4px 15px rgba(0, 104, 166, 0.3)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 20px rgba(0, 104, 166, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(0, 104, 166, 0.3)';
                }}
              >
                View All Job Openings →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Company Information Section */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 50%, rgba(0, 104, 166, 0.1) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Why Choose Bel-Aire Mechanical?</h2>
            <p>Part of the Legence family of companies</p>
          </div>
          
          <div style={{maxWidth: '1200px', margin: '0 auto'}}>
            <div className="careers-cards-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(2, 1fr)', 
              gap: '2rem'
            }}>
              <div className="careers-card careers-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2.5rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 6px 20px rgba(0, 104, 166, 0.2)'
              }}>
                <div className="careers-card-icon" style={{fontSize: '4rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>business</span></div>
                <h3 className="careers-card-title" style={{fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--white)'}}>Legence Family</h3>
                <p className="careers-card-text" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>Access to opportunities across multiple companies in the Legence portfolio.</p>
                <ul className="careers-card-list" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Bel-Aire Mechanical</li>
                  <li>Black Bear Energy</li>
                  <li>CMTA</li>
                  <li>A.O. Reed</li>
                  <li>Gilbert Mechanical</li>
                  <li>And many more...</li>
                </ul>
              </div>
              
              <div className="careers-card careers-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2.5rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 6px 20px rgba(171, 22, 54, 0.2)'
              }}>
                <div className="careers-card-icon" style={{fontSize: '4rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>precision_manufacturing</span></div>
                <h3 className="careers-card-title" style={{fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--white)'}}>State-of-the-Art Facilities</h3>
                <p className="careers-card-text" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>Work in modern, well-equipped facilities designed for excellence.</p>
                <ul className="careers-card-list" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Central Phoenix location</li>
                  <li>Modern manufacturing facilities</li>
                  <li>Advanced equipment and technology</li>
                  <li>Professional work environment</li>
                  <li>Growth opportunities</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;
